module.exports = {
  MAINTENANCE_ODOMETER_EXCEEDED: 'maintenance-odometer-exceeded',
  MAINTENANCE_DATE_EXCEEDED: 'maintenance-date-exceeded',
  OTHER_FAILING_SYSTEM: 'other-failing-system',
  EXCESSIVE_WATER_TEMPERATURE: 'excessive-water-temperature',
  LOW_COOLING_LIQUID_LEVEL: 'low-cooling-liquid-level',
  EXCESSIVE_OIL_TEMPERATURE: 'excessive-oil-temperature',
  LOW_ENGINE_OIL_LEVEL: 'low-engine-oil-level',
  ENGINE_OIL_PRESSURE_ALERT: 'engine-oil-pressure-alert',
  GEARBOX_FAILURE: 'gearbox-failure',
  EXCESSIVE_GEARBOX_OIL_TEMPERATURE: 'excessive-gearbox-oil-temperature',
  HYDRAULIC_PRESSURE_OR_BRAKE_FLUID_INSUFFICIENT: 'hydraulic-pressure-or-brake-fluid-insufficient',
  BRAKING_OIL_LEVEL_LOW: 'braking-oil-level-low',
  ENGINE_CONTROL_SYSTEM_FAILURE: 'engine-control-system-failure',
  WATER_IN_DIESEL_FILTER: 'water-in-diesel-filter',
  ANTI_POLLUTION_SYSTEM_FAILURE: 'anti-pollution-system-failure',
  LOW_DIESEL_ADDITIVE: 'low-diesel-additive',
  BATTERY_CHARGE_OR_POWER_SUPPLY_FAILURE: 'battery-charge-or-power-supply-failure',
  SECONDARY_BATTERY_LOW_CHARGE: 'secondary-battery-low-charge',
  DSG_FAILING: 'dsg-failing',
  BRAKE_PADS_EXCESSIVE_WEAR: 'brake-pads-excessive-wear',
  BRAKING_SYSTEM_FAILURE: 'braking-system-failure',
  PARKING_BRAKE_CONTROL_FAILING: 'parking-brake-control-failing',
  PARKING_BRAKE_OR_HILL_HOLDER_FAILURE: 'parking-brake-or-hill-holder-failure',
  AUTO_PARKING_BRAKE_CONTROL_ACTIVATED: 'auto-parking-brake-control-activated',
  ABS_FAILURE: 'abs-failure',
  ESP_FAILURE: 'esp-failure',
  POWER_STEERING_FAILURE: 'power-steering-failure',
  SUSPENSION_FAILURE: 'suspension-failure',
  SUSPENSION_FAILURE_REDUCE_SPEED: 'suspension-failure-reduce-speed',
  TIRE_PRESSURE_SENSOR_FAILURE: 'tire-pressure-sensor-failure',
  LOW_TIRE_PRESSURE: 'low-tire-pressure',
  FLAT_TIRE: 'flat-tire',
  TIRE_PRESSURE_MONITORING_FAILURE: 'tire-pressure-monitoring-failure',
  SHOCK_SENSOR_FAILING: 'shock-sensor-failing',
  AIRBAG_OR_SAFETY_BELT_FAILURE: 'airbag-or-safety-belt-failure',
  ANTI_POLLUTION_FAILURE_ENGINE_START_IMPOSSIBLE: 'anti-pollution-failure-engine-start-impossible',
  DIRECTIONAL_LIGHT_FAILURE: 'directional-light-failure',
  ELECTRONIC_LOCK_FAILURE: 'electronic-lock-failure',
  SPEED_CONTROL_FAILURE: 'speed-control-failure',
  LOW_FUEL_LEVEL: 'low-fuel-level',
  PARTICLE_FILTER_MIGHT_BE_CLOGGED: 'particle-filter-might-be-clogged',
  AUTOMATIC_LIGHTS_SETTING_FAILURE: 'automatic-lights-setting-failure',
  LOW_WASHER_FLUID: 'low-washer-fluid',
  FLAT_TIRE_FRONT_RIGHT: 'flat-tire-front-right',
  FLAT_TIRE_REAR_LEFT: 'flat-tire-rear-left',
  FLAT_TIRE_REAR_RIGHT: 'flat-tire-rear-right',
  SIDELIGHTS_FAILURE_FRONT_LEFT: 'sidelights-failure-front-left',
  SIDELIGHTS_FAILURE_FRONT_RIGHT: 'sidelights-failure-front-right',
  SIDELIGHTS_FAILURE_REAR_RIGHT: 'sidelights-failure-rear-right',
  SIDELIGHTS_FAILURE_REAR_LEFT: 'sidelights-failure-rear-left',
  DIPPED_BEAM_HEADLAMPS_FAILURE_FRONT_RIGHT: 'dipped-beam-headlamps-failure-front-right',
  DIPPED_BEAM_HEADLAMPS_FAILURE_FRONT_LEFT: 'dipped-beam-headlamps-failure-front-left',
  HEADLIGHTS_FAILURE_RIGHT: 'headlights-failure-right',
  HEADLIGHTS_FAILURE_LEFT: 'headlights-failure-left',
  STOP_LIGHT_FAILURE_RIGHT: 'stop-light-failure-right',
  STOP_LIGHT_FAILURE_LEFT: 'stop-light-failure-left',
  FOG_LIGHT_FAILURE_REAR_LEFT: 'fog-light-failure-rear-left',
  FOG_LIGHT_FAILURE_FRONT_RIGHT: 'fog-light-failure-front-right',
  FOG_LIGHT_FAILURE_REAR_RIGHT: 'fog-light-failure-rear-right',
  FOG_LIGHT_FAILURE_FRONT_LEFT: 'fog-light-failure-front-left',
  TURN_SIGNAL_FAILURE_FRONT_RIGHT: 'turn-signal-failure-front-right',
  TURN_SIGNAL_FAILURE_REAR_RIGHT: 'turn-signal-failure-rear-right',
  TURN_SIGNAL_FAILURE_FRONT_LEFT: 'turn-signal-failure-front-left',
  TURN_SIGNAL_FAILURE_REAR_LEFT: 'turn-signal-failure-rear-left',
  REVERSE_LIGHT_FAILURE_RIGHT: 'reverse-light-failure-right',
  REVERSE_LIGHT_FAILURE_LEFT: 'reverse-light-failure-left',
  ACTIVE_HOOD_FAILURE: 'active-hood-failure',
  PARKING_ASSISTANCE_SYSTEM_FAILURE: 'parking-assistance-system-failure',
  PARKING_SPACE_MEASURING_SYSTEM_FAILURE: 'parking-space-measuring-system-failure',
  LOW_TIRE_PRESSURE_FRONT_LEFT: 'low-tire-pressure-front-left',
  LOW_TIRE_PRESSURE_FRONT_RIGHT: 'low-tire-pressure-front-right',
  LOW_TIRE_PRESSURE_REAR_RIGHT: 'low-tire-pressure-rear-right',
  LOW_TIRE_PRESSURE_REAR_LEFT: 'low-tire-pressure-rear-left',
  SEATBELT_PASSENGER_UNBUCKLED_FRONT_RIGHT: 'seatbelt-passenger-unbuckled-front-right',
  SEATBELT_PASSENGER_UNBUCKLED_REAR_LEFT: 'seatbelt-passenger-unbuckled-rear-left',
  SEATBELT_PASSENGER_UNBUCKLED_REAR_MIDDLE: 'seatbelt-passenger-unbuckled-rear-middle',
  SEATBELT_PASSENGER_UNBUCKLED_REAR_RIGHT: 'seatbelt-passenger-unbuckled-rear-right',
  CROSSING_LINE_SYSTEM_ALERT_FAILURE: 'crossing-line-system-alert-failure',
  ANTI_REVERSE_SYSTEM_FAILING: 'anti-reverse-system-failing',
  POWER_STEERING_ASSISTANCE_FAILURE: 'power-steering-assistance-failure',
  ALERT_COOLANT_TEMP: 'alert-coolant-temp',
  ALERT_BRAKE_FLUID: 'alert-brake-fluid',
  STEERING_FAULT: 'steering-fault',
  FRONT_LEFT_DOOR_OPEN_HIGH_SPEED: 'front-left-door-open-high-speed',
  FRONT_RIGHT_DOOR_OPEN_HIGH_SPEED: 'front-right-door-open-high-speed',
  REAR_LEFT_DOOR_OPEN_HIGH_SPEED: 'rear-left-door-open-high-speed',
  REAR_RIGHT_DOOR_OPEN_HIGH_SPEED: 'rear-right-door-open-high-speed',
  FRONT_LEFT_DOOR_OPEN_LOW_SPEED: 'front-left-door-open-low-speed',
  FRONT_RIGHT_DOOR_OPEN_LOW_SPEED: 'front-right-door-open-low-speed',
  REAR_LEFT_DOOR_OPEN_LOW_SPEED: 'rear-left-door-open-low-speed',
  REAR_RIGHT_DOOR_OPEN_LOW_SPEED: 'rear-right-door-open-low-speed',
  TRUNK_OPEN_HIGH_SPEED: 'trunk-open-high-speed',
  TRUNK_WINDOW_OPEN: 'trunk-window-open',
  BATTERY_LEVEL_FAULT: 'battery-level-fault',
  ENGINE_FAULT: 'engine-fault',
  PREHEATING_DEACTIVATED_BATTERY_TOO_LOW: 'preheating-deactivated-battery-too-low',
  PREHEATING_DEACTIVATED_FUEL_LEVEL_TOO_LOW: 'preheating-deactivated-fuel-level-too-low',
  CHECK_THE_BRAKE_LAMP: 'check-the-brake-lamp',
  RETRACTABLE_ROOF_MECHANISM_FAULT: 'retractable-roof-mechanism-fault',
  ALERT_STEERING_LOCK: 'alert-steering-lock',
  ROOF_OPERATION_IMPOSSIBLE_TEMPERATURE_TOO_HIGH: 'roof-operation-impossible-temperature-too-high',
  ROOF_OPERATION_IMPOSSIBLE_START_ENGINE: 'roof-operation-impossible-start-engine',
  ROOF_OPERATION_IMPOSSIBLE_APPLY_PARKING_BREAK: 'roof-operation-impossible-apply-parking-break',
  HYBRID_SYSTEM_FAULT: 'hybrid-system-fault',
  HYBRID_SYSTEM_FAULT_REPAIRED_THE_VEHICLE: 'hybrid-system-fault-repaired-the-vehicle',
  BATTERY_KEY_ALARM: 'battery-key-alarm',
  PREHEATING_DEACTIVATED_SET_THE_CLOCK: 'preheating-deactivated-set-the-clock',
  TRAILER_CONNECTION_FAULT: 'trailer-connection-fault',
  LIMITED_VISIBILITY_AIDS_CAMERA: 'limited-visibility-aids-camera',
  ELECTRIC_MODE_NOT_AVAILABLE: 'electric-mode-not-available',
  WHEEL_PRESSURE_FAULT: 'wheel-pressure-fault',
  CHECK_SIDE_LAMPS: 'check-side-lamps',
  FRONT_FOGLIGHT_FAULT: 'front-foglight-fault',
  REAR_FOGLIGHT_FAULT: 'rear-foglight-fault',
  CHECK_REVERSING_LAMP: 'check-reversing-lamp',
  ADJUST_TYRE_PRESSURE: 'adjust-tyre-pressure',
  PLACE_GEAR_BOX_TO_P: 'place-gear-box-to-p',
  RISK_OF_ICE: 'risk-of-ice',
  FRONT_RIGHT_DOOR_OPEN: 'front-right-door-open',
  FRONT_LEFT_DOOR_OPEN: 'front-left-door-open',
  REAR_RIGHT_DOOR_OPEN: 'rear-right-door-open',
  REAR_LEFT_DOOR_OPEN: 'rear-left-door-open',
  TRUNK_OPEN: 'trunk-open',
  BOOT_OPEN: 'boot-open',
  REAR_SCREEN_OPEN: 'rear-screen-open',
  ACTIVE_SPOILER_FAULT: 'active-spoiler-fault',
  AUTOMATIC_BRAKING_SYSTEM_FAULT: 'automatic-braking-system-fault',
  DIRECTIONAL_HEADLAMPS_FAULT: 'directional-headlamps-fault',
  SUSPENSION_FAULT_LIMIT_TO90KM: 'suspension-fault-limit-to90km',
  FRONT_LEFT_TYRE_NOT_MONITORED: 'front-left-tyre-not-monitored',
  FRONT_RIGHT_TYRE_NOT_MONITORED: 'front-right-tyre-not-monitored',
  REAR_RIGHT_TYRE_NOT_MONITORED: 'rear-right-tyre-not-monitored',
  REAR_LEFT_TYRE_NOT_MONITORED: 'rear-left-tyre-not-monitored',
  LANE_DEPARTURE_FAULT: 'lane-departure-fault',
  TYRE_UNDER_INFLATION: 'tyre-under-inflation',
  SPARE_WHEEL_FITTED_DRIVING_AIDS_DEACTIVATED: 'spare-wheel-fitted-driving-aids-deactivated',
  AUTOMATIC_BRAKING_DEACTIVATED: 'automatic-braking-deactivated',
  TOP_UP_AD_BLUE: 'top-up-ad-blue',
  LONG_PUSH_TO_UNLOCK_TANK_FAULT: 'long-push-to-unlock-tank-fault',
  TRANSMISSION_FAULT: 'transmission-fault',
  ALTERNATOR_FAIL: 'alternator-failure',
  CMD_IGN_FAIL_STS: 'ignition-failure',
  DRIVING_RANGE_FUEL_WARNING: 'driving-range-fuel-warning',
  BRAKE_PADS_PRE_WARNING: 'brake-pads-pre-warning',
  BRAKE_PADS_WARNING: 'brake-pads-warning',
  FRONT_LEFT_WINDOWS_OPEN: 'front-left-windows-open',
  FRONT_RIGHT_WINDOWS_OPEN: 'front-right-windows-open',
  REAR_LEFT_WINDOWS_OPEN: 'rear-left-windows-open',
  REAR_RIGHT_WINDOWS_OPEN: 'rear-right-windows-open',
  TRUNK_LOCKED: 'trunk-locked',
  TRUNK_HOOD_OPEN: 'trunk-hood-open',
  TRUNK_HOOD_OPEN_LOW_SPEED: 'trunk-hood-open-low-speed',
  SHIFT_TO_PARK: 'shift-to-park',
  ELECTRIC_TRACTION_SYSTEM_FAULT: 'electric-traction-system-fault',
  ELECTRIC_TRACTION_SYSTEM_FAILURE_LIMIT_SPEED: 'electric-traction-system-failure-limit-speed',
  ELECTRIC_TRACTION_SYSTEM_FAILURE_STOP_VEHICLE: 'electric-traction-system-failure-stop-vehicle',
  COLLISION_DETECTION_SYSTEM_FAULT: 'collision-detection-system-fault',
  COLLISION_MITIGATION_SYSTEM_FAULT: 'collision-mitigation-system-fault',
  AIRBAG_OR_SEATBELT_PRETENTIONER_OR_ACTIVE_HOOD_FAILURE: 'airbag-or-seatbelt-pretentionser-or-active-hood-failure',
};
